// ============================================================================
// BLOSSOM - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'blossom',
  name: 'Blossom Algorithm',
  category: 'Graphs',
  complexity: {
    time: 'O(V²E)',
    space: 'O(V²)'
  },
  description: 'An algorithm for finding maximum matchings in general graphs. It uses the concept of blossoms (odd-length cycles) to augment the matching and handles general graphs, not just bipartite graphs.'
};
